/**
 * Маппинг эмодзи на SVG иконки
 * Используется для замены эмодзи-иконок на векторные SVG
 */
export const iconMap = {
  '👥': 'social/people', // Клиенты
  '👤': 'social/person', // Пользователь
  '📊': 'editor/bar_chart', // Статистика/графики
  '💸': 'Action/account_balance_wallet', // Деньги/оборот
  '🎯': 'device/gps_fixed', // Цель/средний обмен
  '🔍': 'Action/search', // Поиск
  '💼': 'Action/work', // Сделки
  '📞': 'comminication/phone', // Телефон
  '📝': 'editor/notes', // Заметки
  '🏠': 'navigation/home_work', // Дом/главная
  '💱': 'Action/swap_vert', // Обмен валют
  '📈': 'Action/trending_up', // Рост
  '📉': 'Action/trending_down', // Падение
  '⚙️': 'Action/settings', // Настройки
  '🎨': 'editor/format_paint', // Дизайн/темы
  '✅': 'Action/check_circle', // Успех
  '❌': 'navigation/cancel', // Ошибка
  '🔄': 'Action/cached', // Обновление
  '💰': 'Action/account_balance_wallet', // Деньги
  '📱': 'device/devices', // Телефон/устройство
  '🔗': 'content/link', // Связь
  '📋': 'Action/list', // Список
  '💡': 'Action/lightbulb_outline', // Идея/подсказка
  // '🚀': 'Action/rocket_launch', // Запуск - иконка не найдена, используется fallback на эмодзи
  '⭐': 'Action/star_rate', // Звезда
  '❤️': 'Action/favorite', // Избранное
  '💾': 'content/save', // Сохранение
  '➡️': 'navigation/arrow_forward', // Стрелка вправо
  // '🇷🇺': 'maps/flag', // Флаг России - иконка не найдена, используется fallback на эмодзи
  // '🇺🇸': 'maps/flag', // Флаг США - иконка не найдена, используется fallback на эмодзи
  // '🇪🇺': 'maps/flag', // Флаг ЕС - иконка не найдена, используется fallback на эмодзи
  '🏛️': 'Action/account_balance', // Банк/учреждение
  '⏳': 'Action/hourglass_empty', // Ожидание
};

/**
 * Получить путь к иконке по эмодзи
 * @param {string} emoji - Эмодзи символ
 * @returns {string|null} - Путь к иконке или null
 */
export const getIconPath = (emoji) => {
  return iconMap[emoji] || null;
};
